<template>
    <nav>
        <ul>
            <li>
                <router-link 
                    to="/bim_library_market" 
                    :class="{ 
                        'active': 
                            $route.path === '/bim_library_market' ||
                            $route.path === '/bim_library_market_view'
                    }">
                    BIM-라이브러리 마켓<span class="arw material-symbols-outlined">arrow_forward_ios</span>
                </router-link>
            </li>
            <li>
                <a href="#"
                       @click.prevent="goDesignSimulation"
                       :class="{ 
                           active: 
                               $route.path === '/design_simulation' ||
                               $route.path === '/design_simulation_view'
                       }">
                        설계 및 시뮬레이션
                        <span class="arw material-symbols-outlined">arrow_forward_ios</span>
                </a>
            </li>
            <li>
                <a href="#"
                   @click.prevent="goMaintenance"
                   :class="{ 
                       active: 
                           $route.path === '/maintenance' ||
                           $route.path === '/maintenance_write' ||
                           $route.path === '/maintenance_view'
                   }">
                    유지관리 서비스
                    <span class="arw material-symbols-outlined">arrow_forward_ios</span>
                </a>
            </li>
            <li>
                <router-link 
                    to="/zeb_manufacturer" 
                    :class="{ 
                        'active': 
                            $route.path === '/zeb_manufacturer' ||
                            $route.path === '/bipv_modul'
                    }">
                    ZEB 제조사<span class="arw material-symbols-outlined">arrow_forward_ios</span>
                </router-link>
            </li>
            <li>
                <router-link 
                    to="/online_seminar" 
                    :class="{ 
                        'active': 
                            $route.path === '/online_seminar'
                    }">
                    온라인 세미나<span class="arw material-symbols-outlined">arrow_forward_ios</span>
                </router-link>
            </li>
            <template v-if="isLoggedIn">
                <li class="mob_only"><router-link to="/profile_edit">정보수정<span class="arw material-symbols-outlined">arrow_forward_ios</span></router-link></li>
                <li class="mob_only"><router-link to="/point_history">포인트내역<span class="arw material-symbols-outlined">arrow_forward_ios</span></router-link></li>
            </template>
        </ul>
        <ul class="link">
            <li class="btn"><a href="/inquire_form">문의하기</a></li>
            
            <template v-if="!isLoggedIn">
                <li><a href="/login_form">로그인</a></li>
                <li><a href="/register_form">회원가입</a></li>
            </template>

            <template v-else>
                <li class="user_menu_wrap" @mouseenter="userMenu = true" @mouseleave="userMenu = false">
                    <a href="#" class="user_name"><strong>{{ user.name }}</strong>님</a>
                    <ul class="user_dropdown" v-show="userMenu">
                        <li><router-link to="/register_form">정보수정</router-link></li>
                        <li><router-link to="/point_history">포인트내역</router-link></li>
                        <li><a href="#" @click.prevent="logout">로그아웃</a></li>
                    </ul>
                </li>
                <li class="pc_only"><a href="#" @click.prevent="logout">로그아웃</a></li>
            </template>
        </ul>
    </nav>
</template>

<script>
import api from "@/api";

export default {
    name: "MainMenu",
    data() {
        return {
            isLoggedIn: false,
            user: null,
            userMenu: false,    
        };
    },
    async mounted() {
        await this.checkAuth();
    },
    methods: {
        async checkAuth() {
            try {
                const response = await api.get('/admin/auth_check', { withCredentials: true });

                if (response.data.logged_in) {
                    this.isLoggedIn = true;
                    this.user = response.data.user;
                } else {
                    this.isLoggedIn = false;
                    this.user = null;
                }
            } catch (e) {
                console.error("Auth check failed:", e);
            }
        },

        goDesignSimulation() {
            /*
            if (!this.isLoggedIn) {
                alert("로그인이 필요한 서비스입니다.\n\n로그인 페이지로 이동합니다");
                window.location.href = '/login_form?reffer=/design_simulation';
                return;
            }
            */    

            this.$router.push('/design_simulation');
        },

        goMaintenance() {
            if (!this.isLoggedIn) {
                alert("로그인이 필요한 서비스입니다.\n\n로그인 페이지로 이동합니다");
                window.location.href = '/login_form?reffer=/maintenance';
                return;
            }

            this.$router.push('/maintenance');
        },

        async logout() {
            try {
                await api.post('/admin/logout', {}, { withCredentials: true });
                window.location.href='/';
            } catch (e) {
                console.error(e);
            }
        }
    }
}
</script>

